import { OnInit, Input, OnDestroy, Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { ApiCallStateService } from '@services';
import { EApiRequestPartKeys } from '@enums';
import { EBitfApiSortDirection } from '@bitf/enums';
import { BitfApiRequestPart } from '@bitf/core/api-call-state/bitf-api-request-part';
import { IBitfSortOption } from '@interfaces';

@Component({
  selector: 'bitf-sort',
  template: '',
})
export class BitfSortComponent implements OnInit, OnDestroy {
  @Input()
  apiCallStateName;

  @Input()
  apiRequestPartKey = EApiRequestPartKeys.SORTING;

  // Use for type dropdown
  @Input()
  options: IBitfSortOption[] = [];

  // Use for type button
  @Input()
  option: IBitfSortOption;

  EBitfApiSortDirection = EBitfApiSortDirection;

  formControl = new FormControl(null);
  private subscription: Subscription = new Subscription();
  private requestPart: BitfApiRequestPart;

  constructor(private apiCallStateService: ApiCallStateService) {}

  ngOnInit() {
    this.requestPart = this.apiCallStateService.getRequestPart(this.apiCallStateName, this.apiRequestPartKey);

    if (this.isDropDown()) {
      this.initDropdown();
    } else {
      this.updateSortState();
      this.subscription = this.apiCallStateService.getStateStore$(this.apiCallStateName).subscribe(() => {
        this.updateSortState();
      });
    }
  }

  // Dropdown
  onSelectionChange(event) {
    this.requestPart.data = event.value.property ? event.value : undefined;
    this.dispatchEvent();
  }

  // Button
  sort(option: IBitfSortOption) {
    switch (option.value.direction) {
      case EBitfApiSortDirection.ASC:
        this.requestPart.data.direction = EBitfApiSortDirection.DESC;
        break;
      case EBitfApiSortDirection.DESC:
        this.requestPart.data.direction = EBitfApiSortDirection.UNDEFINED;
        break;
      case EBitfApiSortDirection.UNDEFINED:
        this.requestPart.data.direction = EBitfApiSortDirection.ASC;
        break;
    }
    this.dispatchEvent();
  }

  isDropDown(): boolean {
    return this.options.length > 0;
  }

  private initDropdown() {
    const data = this.requestPart.data;
    if (data) {
      const option = this.options.find(
        item => item.value.property === data.property && item.value.direction === data.direction
      ).value;
      this.formControl.patchValue(option);
    }
  }

  private updateSortState() {
    if (this.requestPart.data) {
      this.option.value.direction = this.requestPart.data.direction;
    }
  }

  private dispatchEvent() {
    const paginationRequestPart = this.apiCallStateService.getRequestPart(
      this.apiCallStateName,
      EApiRequestPartKeys.PAGINATION
    );

    this.apiCallStateService.setStore(() => {
      paginationRequestPart.reset();
    }, this.apiCallStateName);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
